<template>
<section class="recent_car gray_section" v-show="recentCars.length > 0">
    <div class="wrap">

        <h2 class="section_title">최근 본 모델</h2>

        <swiper v-show="recentCars.length > 0"
            class="swiper recent_car_ul"
            :options="swiperOption"
        >
            <swiper-slide class="item" 
                v-for="(recentCar,idx) in recentCars" 
                :key="`recent-car-item-${idx}`"
            >
                <router-link :to="`vehicleInfo/${recentCar.id}`">
                    <div class="img"><img :src="recentCar.modelUrl"/></div>
                    <p><span>{{recentCar.modelName}}</span><br>{{recentCar.trimName}}</p>
                </router-link>
            </swiper-slide>
        </swiper>

    </div> 
</section>
</template>

<script>
export default {
    name:'MainRecentCar',
    components: {
    },
    data() {
        return {
            swiperOption: {
                autoHeight: true, //enable auto height
                slidesPerView: 4, //화면에 slide 노출 개수
                spaceBetween: 10, //거리
            },
            recentCars: [],
        }
    },
    props: {
        onload: {
            type: Boolean,
            default: false,
        },
    },
    // computed: {
    //     ...mapState({
    //         onload: state => state.common.onload,
    //     })
    // },
    watch: {
        onload(val) {
            if(val) {
                let localStorageRecentCars = localStorage.getItem('userId-recentCars');
                if(localStorageRecentCars) {
                    this.recentCars = JSON.parse(localStorageRecentCars);
                }                
            }
        }
    },
    created () {
        
    },
    methods: {
    },
}
</script>

<style scoped>

</style>